var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.92227 1.15475C10.3397 0.258594 12.2227 0.011018 13.8494 0.532321C17.3878 1.67344 18.4862 5.53091 17.5037 8.60032C15.9878 13.4211 9.51331 17.017 9.23871 17.1678C9.14108 17.2219 9.03298 17.2489 8.92489 17.2489C8.81679 17.2489 8.70957 17.2227 8.61193 17.1696C8.33907 17.0205 1.9117 13.4777 0.345173 8.60119C0.344301 8.60119 0.344301 8.60032 0.344301 8.60032C-0.639027 5.53004 0.455885 1.67169 3.99081 0.532321C5.65061 -0.00467345 7.45948 0.231569 8.92227 1.15475ZM4.39181 1.77717C1.53162 2.69948 0.8133 5.77587 1.59002 8.20193C2.81221 12.0045 7.64081 15.0791 8.92401 15.8402C10.2116 15.0713 15.075 11.9626 16.258 8.20542C17.0347 5.77674 16.3138 2.70035 13.4492 1.77717C12.0614 1.33171 10.4426 1.60282 9.32502 2.4676C9.09139 2.64717 8.7671 2.65066 8.53173 2.47283C7.3479 1.58277 5.80142 1.32212 4.39181 1.77717Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.649eb956.svg";
export { ForwardRef as ReactComponent };